<script>
import {
  BModal, BForm, BFormInput, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import store from '@/store'

export default {
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormTextarea,
  },
  model: {
    prop: 'blankData',
    event: 'input',
  },
  props: {
    blankData: {
      type: Object,
      default: () => ({
        id: null,
        action: '',
        subject: '',
        descricao: '',
      }),
    },
    idModal: {
      type: String,
      default: 'modal_new_edit_ability',
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'id', label: '#', sortable: true,
        },
        { key: 'subject', label: 'Fução' },
        { key: 'action', label: 'Ações' },
        { key: 'ability', label: 'Ativar' },
      ],
      items: [
        {
          id: 1,
          ability: 'Cliente B2B',
          created: true,
          updated: false,
          read: true,
        },
      ],
    }
  },
  computed: {
    labelBtnModal() {
      return this.blankData.id !== null ? 'Atualizar' : 'Cadastrar'
    },
  },
  methods: {
    resetBlacnkGrupoData() {
      this.items.map(item => {
        item.checked = false
        return item
      })
      this.$emit('input', {
        id: null,
        action: '',
        subject: '',
        descricao: '',
      })
    },
    resolveAbilityAction(ability) {
      if (ability === 'update') return 'Atualizar'
      if (ability === 'manage') return 'Gerenciar'
      if (ability === 'delete') return 'Deletar'
      if (ability === 'create') return 'Criar'
      return 'Ver'
    },

    resolveAbiliteSubject(ability) {
      if (ability === 'all') return 'Tudo'
      if (ability === 'ACL') return 'Permissões'
      return ability
    },
    onChangeAbility(item) {
      this.$emit('input', {
        ...this.blankData,
        abilities: this.items.filter(ab => ab.checked).map(i => i.id),
      })
      this.items.map(i => {
        if (i.id === item.id) {
          i.checked = !i.checked
        }
        return i
      })
    },
    handleSubmit() {
      if (this.blankData.id !== null) {
        store.dispatch('abilityStore/update', {
          ...this.blankData,
        })
          .then(() => {
            this.$emit('refetchData')
          })
        return
      }
      store.dispatch('abilityStore/create', {
        ...this.blankData,
      })
        .then(() => {
          this.$emit('refetchData')
        })
      this.resetBlacnkGrupoData()
    },
  },
}
</script>

<template>
  <b-modal
    :id="idModal"
    cancel-variant="outline-secondary"
    :ok-title="labelBtnModal"
    cancel-title="Cancelar"
    centered
    size="lg"
    :title="`${labelBtnModal} Abilidade`"
    @ok="handleSubmit"
    @close="resetBlacnkGrupoData($event)"
    @cancel="resetBlacnkGrupoData($event)"
  >
    <b-form class="row">
    <div class="col-6">
      <b-form-group>
        <label for="nome_grupo">Action:</label>
        <b-form-input
            id="nome_grupo"
            v-model="blankData.action"
            type="text"
            name="nome_grupo"
            placeholder="Nome do grupo"
        />
      </b-form-group>
    </div>

      <div class="col-6">
        <b-form-group>
          <label for="nome_grupo">Subject:</label>
          <b-form-input
              id="nome_grupo"
              v-model="blankData.subject"
              type="text"
              name="nome_grupo"
              placeholder="Nome do grupo"
          />
        </b-form-group>
      </div>
      <div class="col-12">
        <label for="textarea-default">Descrição</label>
        <b-form-textarea
            id="textarea-default"
            placeholder="Textarea"
            rows="3"
            v-model="blankData.descricao"
        />
      </div>
    </b-form>
  </b-modal>
</template>

<style scoped>
.form-add-grupo__table .vs__deselect {
  fill: white;
}

</style>
